import { gql } from '@apollo/client';

export const CREATE_ZUORA_LINK_TOKEN = gql`
  mutation Flex_CreateZuoraLinkToken($input: CreateZuoraLinkTokenInput!) {
    createZuoraLinkToken(input: $input) {
      digitalSignature {
        key
        signature
        token
        tenantId
        success
      }
      hostedPageId
      hostedPageUri
    }
  }
`;
